
/**
 * Global Functions
 */

$.fn.toaster = function () {
    return this.each(function() {
        var toaster_type = $(this).attr('data-type') || 'toast';
        var toaster_delay = $(this).attr('data-delay') || false;
        var toaster_link = $(this).attr('data-link') || false;
        var toaster_svg = $(this).attr('data-svg') || false;
        var toaster_img = $(this).attr('data-img') || false;
        var toaster_link_class = $(this).attr('data-link-class') || '';
        var toaster_id = $(this).attr('data-id') || 'toaster-' + Math.floor(1000 + Math.random() * 9000);
        var toaster_svg_2 = '<svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 320 512"><path fill="currentColor" d="M207.6 256l107.72-107.72c6.23-6.23 6.23-16.34 0-22.58l-25.03-25.03c-6.23-6.23-16.34-6.23-22.58 0L160 208.4 52.28 100.68c-6.23-6.23-16.34-6.23-22.58 0L4.68 125.7c-6.23 6.23-6.23 16.34 0 22.58L112.4 256 4.68 363.72c-6.23 6.23-6.23 16.34 0 22.58l25.03 25.03c6.23 6.23 16.34 6.23 22.58 0L160 303.6l107.72 107.72c6.23 6.23 16.34 6.23 22.58 0l25.03-25.03c6.23-6.23 6.23-16.34 0-22.58L207.6 256z"></path></svg>';
        var toaster_nohide = $(this).attr('data-nohide') || false;

        if (toaster_svg === 'smie') {
            var toaster_svg_1 = '<svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 496 512"><path fill="currentColor" d="M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm63.7 128.7c7.6-11.4 24.7-11.7 32.7 0 12.4 18.4 15.1 36.9 15.7 55.3-.5 18.4-3.3 36.9-15.7 55.3-7.6 11.4-24.7 11.7-32.7 0-12.4-18.4-15.1-36.9-15.7-55.3.5-18.4 3.3-36.9 15.7-55.3zm-160 0c7.6-11.4 24.7-11.7 32.7 0 12.4 18.4 15.1 36.9 15.7 55.3-.5 18.4-3.3 36.9-15.7 55.3-7.6 11.4-24.7 11.7-32.7 0-12.4-18.4-15.1-36.9-15.7-55.3.5-18.4 3.3-36.9 15.7-55.3zM248 432c-60.6 0-134.5-38.3-143.8-93.3-2-11.8 9.3-21.6 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.4-3.7 22.6 6.1 20.7 17.9-9.3 55-83.2 93.3-143.8 93.3z"></path></svg>';
        } else if (toaster_svg === 'warning') {
            var toaster_svg_1 = '<svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><g class="fa-group"><path class="fa-secondary" fill="currentColor" d="M569.52 440L329.58 24c-18.44-32-64.69-32-83.16 0L6.48 440c-18.42 31.94 4.64 72 41.57 72h479.89c36.87 0 60.06-40 41.58-72zM288 448a32 32 0 1 1 32-32 32 32 0 0 1-32 32zm38.24-238.41l-12.8 128A16 16 0 0 1 297.52 352h-19a16 16 0 0 1-15.92-14.41l-12.8-128A16 16 0 0 1 265.68 192h44.64a16 16 0 0 1 15.92 17.59z" opacity="0.4"></path><path class="fa-primary" fill="currentColor" d="M310.32 192h-44.64a16 16 0 0 0-15.92 17.59l12.8 128A16 16 0 0 0 278.48 352h19a16 16 0 0 0 15.92-14.41l12.8-128A16 16 0 0 0 310.32 192zM288 384a32 32 0 1 0 32 32 32 32 0 0 0-32-32z"></path></g></svg>';
        } else if (toaster_svg === 'info') {
            var toaster_svg_1 = '<svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><g class="fa-group"><path class="fa-secondary" fill="currentColor" d="M256 8C119 8 8 119.08 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 110a42 42 0 1 1-42 42 42 42 0 0 1 42-42zm56 254a12 12 0 0 1-12 12h-88a12 12 0 0 1-12-12v-24a12 12 0 0 1 12-12h12v-64h-12a12 12 0 0 1-12-12v-24a12 12 0 0 1 12-12h64a12 12 0 0 1 12 12v100h12a12 12 0 0 1 12 12z" opacity="0.4"></path><path class="fa-primary" fill="currentColor" d="M256 202a42 42 0 1 0-42-42 42 42 0 0 0 42 42zm44 134h-12V236a12 12 0 0 0-12-12h-64a12 12 0 0 0-12 12v24a12 12 0 0 0 12 12h12v64h-12a12 12 0 0 0-12 12v24a12 12 0 0 0 12 12h88a12 12 0 0 0 12-12v-24a12 12 0 0 0-12-12z"></path></g></svg>';
        } else if (toaster_svg === 'cart-plus') {
            var toaster_svg_1 = '<svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path fill="currentColor" d="M504.717 320H211.572l6.545 32h268.418c15.401 0 26.816 14.301 23.403 29.319l-5.517 24.276C523.112 414.668 536 433.828 536 456c0 31.202-25.519 56.444-56.824 55.994-29.823-.429-54.35-24.631-55.155-54.447-.44-16.287 6.085-31.049 16.803-41.548H231.176C241.553 426.165 248 440.326 248 456c0 31.813-26.528 57.431-58.67 55.938-28.54-1.325-51.751-24.385-53.251-52.917-1.158-22.034 10.436-41.455 28.051-51.586L93.883 64H24C10.745 64 0 53.255 0 40V24C0 10.745 10.745 0 24 0h102.529c11.401 0 21.228 8.021 23.513 19.19L159.208 64H551.99c15.401 0 26.816 14.301 23.403 29.319l-47.273 208C525.637 312.246 515.923 320 504.717 320zM408 168h-48v-40c0-8.837-7.163-16-16-16h-16c-8.837 0-16 7.163-16 16v40h-48c-8.837 0-16 7.163-16 16v16c0 8.837 7.163 16 16 16h48v40c0 8.837 7.163 16 16 16h16c8.837 0 16-7.163 16-16v-40h48c8.837 0 16-7.163 16-16v-16c0-8.837-7.163-16-16-16z"></path></svg>';
        } else if (toaster_svg === 'check') {
            var toaster_svg_1 = '<svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><g class="fa-group"><path class="fa-secondary" fill="currentColor" d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm155.31 195.31l-184 184a16 16 0 0 1-22.62 0l-104-104a16 16 0 0 1 0-22.62l22.62-22.63a16 16 0 0 1 22.63 0L216 308.12l150.06-150.06a16 16 0 0 1 22.63 0l22.62 22.63a16 16 0 0 1 0 22.62z" opacity="0.4"></path><path class="fa-primary" fill="currentColor" d="M227.31 387.31a16 16 0 0 1-22.62 0l-104-104a16 16 0 0 1 0-22.62l22.62-22.63a16 16 0 0 1 22.63 0L216 308.12l150.06-150.06a16 16 0 0 1 22.63 0l22.62 22.63a16 16 0 0 1 0 22.62l-184 184z"></path></g></svg>';
        } else if (toaster_svg === 'cart') {
            var toaster_svg_1 = '<svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path fill="currentColor" d="M528.12 301.319l47.273-208C578.806 78.301 567.391 64 551.99 64H159.208l-9.166-44.81C147.758 8.021 137.93 0 126.529 0H24C10.745 0 0 10.745 0 24v16c0 13.255 10.745 24 24 24h69.883l70.248 343.435C147.325 417.1 136 435.222 136 456c0 30.928 25.072 56 56 56s56-25.072 56-56c0-15.674-6.447-29.835-16.824-40h209.647C430.447 426.165 424 440.326 424 456c0 30.928 25.072 56 56 56s56-25.072 56-56c0-22.172-12.888-41.332-31.579-50.405l5.517-24.276c3.413-15.018-8.002-29.319-23.403-29.319H218.117l-6.545-32h293.145c11.206 0 20.92-7.754 23.403-18.681z"></path></svg>';
        } else if (toaster_svg === 'delivery') {
            var toaster_svg_1 = '<svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><defs/><path d="M454.4 317.8h-10.1v-68.4c0-8-3.2-15.8-8.9-21.5l-63.2-63.2c-5.7-5.7-13.4-8.9-21.5-8.9h-27.9v-30.4c0-16.8-13.6-30.4-30.4-30.4H89.9c-16.8 0-30.4 13.6-30.4 30.4v202.5c0 16.8 13.6 30.4 30.4 30.4H100c0 33.5 27.2 60.8 60.8 60.8s60.8-27.2 60.8-60.8h81c0 33.5 27.2 60.8 60.8 60.8s60.8-27.2 60.8-60.8h30.4c5.6 0 10.1-4.6 10.1-10.1V328c-.2-5.7-4.8-10.2-10.3-10.2zm-293.6 70.8c-16.8 0-30.4-13.6-30.4-30.4s13.6-30.4 30.4-30.4 30.4 13.6 30.4 30.4-13.7 30.4-30.4 30.4zm202.4 0c-16.8 0-30.4-13.6-30.4-30.4s13.6-30.4 30.4-30.4 30.4 13.6 30.4 30.4-13.6 30.4-30.4 30.4zM413.9 257h-91.1v-70.9h27.9l63.2 63.2v7.7z"/></svg>';
        } else if (toaster_svg === 'deliveryfree') {
            var toaster_svg_1 = '<svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><defs/><path d="M232.2 171.1c-2.2-2.2-5.7-2.2-7.9 0l-52.2 52.2-24.4-24.4c-2.2-2.2-5.7-2.2-7.9 0l-7.9 7.9c-2.2 2.2-2.2 5.7 0 7.9l36.2 36.2c2.2 2.2 5.7 2.2 7.9 0l64.1-64.1c2.2-2.2 2.2-5.7 0-7.9l-7.9-7.8z"/><path d="M464.4 320.9h-10.6v-72c0-8.5-3.4-16.6-9.4-22.6l-66.5-66.5c-6-6-14.1-9.4-22.6-9.4h-29.4v-31.9c0-17.6-14.3-32-31.9-32H81c-17.6 0-31.9 14.3-31.9 32v213c0 17.6 14.3 32 31.9 32h10.7c0 35.3 28.6 63.9 63.9 63.9s63.9-28.6 63.9-63.9h85.2c0 35.3 28.6 63.9 63.9 63.9s63.9-28.6 63.9-63.9h32c5.9 0 10.6-4.8 10.6-10.6v-21.3c-.1-5.9-4.9-10.7-10.7-10.7zm-308.9 74.6c-17.6 0-31.9-14.3-31.9-32s14.3-32 31.9-32 31.9 14.3 31.9 32-14.3 32-31.9 32zm30.5-104c-47.7 0-86.4-38.7-86.4-86.4s38.7-86.4 86.4-86.4 86.4 38.7 86.4 86.4-38.7 86.4-86.4 86.4zm182.5 104c-17.6 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.4 32-32 32zM421.8 257h-95.9v-74.6h29.4l66.5 66.5v8.1z"/></svg>';
        } else if (toaster_svg === 'gift') {
            var toaster_svg_1 = '<svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><defs/><path d="M256 8a248 248 0 100 496 248 248 0 000-496z" opacity=".4"/><path d="M107 381c0 12 10 22 22 22h107V295H107v86zm172 22h108c12 0 21-10 21-22v-86H279v108zm129-215h-28c4-8 7-17 7-27 0-33-27-59-59-59-28 0-46 14-70 46-23-32-41-46-69-46-32 0-59 27-59 59 0 10 3 19 7 27h-30c-12 0-21 10-21 22v53c0 6 5 11 10 11h323c6 0 11-5 11-11v-54c0-11-10-21-22-21zm-219 0a27 27 0 010-54c13 0 23 2 58 54h-58zm139 0h-58c34-51 44-54 57-54a27 27 0 011 54z"/></svg>';
        } else {
            toaster_svg_1 = false;
        }

        if (toaster_link === false) {
            var toaster_link_a = '<div class="col p-0">';
            var toaster_link_b = '</div>';
        } else {
            var toaster_link_a = '<a href="' + toaster_link + '" class="toaster-link '+ toaster_link_class +' col p-0">';
            var toaster_link_b = '</a>';
        }

        if (toaster_delay === false) {
            var toaster_delay_autohide = 'data-autohide="false"';
        } else {
            var toaster_delay_autohide = 'data-delay="'+ toaster_delay + '"';
        }

        if (toaster_svg === false) {
            var toaster_svg_html = '';
            var toaster_svg_line = 'pl-lg-4';
        } else {
            var toaster_svg_html = '<div class="col-auto pl-3 pr-0 pl-lg-4 pr-lg-3 py-2 py-lg-3 font-em-sm-15 font-em-lg-25 d-flex align-items-center"><i class="svg-icon toaster-svg">' + toaster_svg_1 + '</i></div>';
            var toaster_svg_line = 'toaster-lg-line w-100';
        }

        if (toaster_img === false) {
            var toaster_img_html = '';
            var toaster_img_line = 'pl-lg-4';
        } else {
            var toaster_img_html = '<div class="col-auto px-2 py-2 py-lg-2 d-flex align-items-center"><div class="toaster-product product-shadow px-1"><img src="' + toaster_img + '" alt="img" class="toaster-product-img w-100 mw-100 mh-100" /></div></div>';
            var toaster_img_line = 'toaster-lg-line w-100';
        }

        if (toaster_type === 'toast') {
            $('#toaster-place').prepend('' +
                '<div id="' + toaster_id + '" class="toaster toast toaster-shadow" role="alert" aria-live="assertive" aria-atomic="true" ' + toaster_delay + ' '+ toaster_delay_autohide +'><div class="toaster-inner position-relative"><div class="row m-0">' +
                toaster_link_a + '<div class="row m-0 w-100">' + toaster_svg_html +
                '<div class="col p-0 py-3 d-flex align-items-center"><div class="'+ toaster_svg_line +' pl-3 pr-2">' +
                $(this).html() +
                '</div></div></div>' +
                toaster_link_b + '<div class="toaster-link col-auto p-2 pr-3 p-lg-3 toaster-close d-flex justify-content-center align-items-center" data-dismiss="toast"><i class="svg-icon">' + toaster_svg_2 + '</i></div></div></div></div>');
        } else if (toaster_type === 'product') {
            $('#toaster-place').prepend('' +
                '<div id="' + toaster_id + '" class="toaster toast toaster-shadow" role="alert" aria-live="assertive" aria-atomic="true" ' + toaster_delay + ' '+ toaster_delay_autohide +'><div class="toaster-inner position-relative"><div class="row m-0">' +
                toaster_link_a + '<div class="row m-0 w-100">' + toaster_img_html +
                '<div class="col p-0 py-2 d-flex align-items-center"><div class="'+ toaster_img_line +' pl-2 pr-2">' +
                $(this).html() +
                '</div></div></div>' +
                toaster_link_b + '<div class="toaster-link col-auto p-2 pr-3 p-lg-3 toaster-close d-flex justify-content-center align-items-center" data-dismiss="toast"><i class="svg-icon">' + toaster_svg_2 + '</i></div></div></div></div>');
        }

        $('#'+toaster_id).toast('show');
        $('#'+toaster_id).on('hidden.bs.toast', function () {
            $('#'+toaster_id).remove();
        })
        if (toaster_nohide === false) {
            $(this).remove();
        }
    });

};


// functions for vertical grid arrows
function ProductGridListArrows() {
    $(".product-grid-list-arrow").click(function (e) {
        let container = $(this).closest('.product-vertical');
        let children = container.find('.product-grid-list').children();
        let lastItem = parseInt(container.attr('data-left'));
        let hiddenItems = children.length - lastItem;
        let basePosition = typeof container.attr('data-start') == 'string'
            ? parseInt(container.attr('data-start'))
            : container.attr('data-start');
        let step = container.attr('data-step')
            ? parseInt(container.attr('data-step'))
            : 4;
        let newLastItem = 0;
        let move = 0;
        let newMargin = 0;

        if (typeof basePosition == 'undefined') {
            container.attr('data-start', lastItem);
            basePosition = lastItem;
        }

        let itemSize = 100 / basePosition;

        if ($(this).hasClass('for-right')) {
            if (hiddenItems > step) {
                move = step;
            } else {
                move = hiddenItems;
            }
            newLastItem = lastItem + move;
            container.attr('data-left', newLastItem);
            newMargin = -(itemSize * (newLastItem - basePosition));
        } else {
            if (basePosition <= lastItem - step) {
                move = step;
            } else {
                move = lastItem - basePosition;
            }
            newLastItem = lastItem - move;
            container.attr('data-left', newLastItem);
            newMargin = -(itemSize * (newLastItem - basePosition));
        }

        container.find('.product-box-item-small:first-child').css('margin-left', 'calc(' + newMargin + '% + .5rem)');

        if (children.length === newLastItem) {
            container.addClass('is-end');
        } else {
            container.removeClass('is-end');
        }

        if (newLastItem === basePosition) {
            container.addClass('is-start');
        } else {
            container.removeClass('is-start');
        }
    })
}

$(function () {
    $('[data-toggle="popover"]').popover()
})


function removeCookie(sKey, sPath, sDomain) {
    document.cookie = encodeURIComponent(sKey) +
        "=; expires=Thu, 01 Jan 1970 00:00:00 GMT" +
        (sDomain ? "; domain=" + sDomain : "") +
        (sPath ? "; path=" + sPath : "");
}


(function() {
    'use strict';
    window.addEventListener('load', function() {
        // Fetch all the forms we want to apply custom Bootstrap validation styles to
        var forms = document.getElementsByClassName('needs-validation');
        // Loop over them and prevent submission
        var validation = Array.prototype.filter.call(forms, function(form) {
            form.addEventListener('submit', function(event) {
                if (form.checkValidity() === false) {
                    event.preventDefault();
                    event.stopPropagation();
                }
                form.classList.add('was-validated');
            }, false);
        });
    }, false);
})();


$('.btn-loading').on('click', function() {
    var $this = $(this);
    $this.button('loading');
    setTimeout(function() {
        $this.button('reset');
    }, 8000);
});


(function($) {
    $.fn.button = function(action) {
        if (action === 'loading' && this.data('loading-text')) {
            this.data('original-text', this.html()).html(this.data('loading-text')).prop('disabled', true);
        }
        if (action === 'reset' && this.data('original-text')) {
            this.html(this.data('original-text')).prop('disabled', false);
        }
    };
}(jQuery));


//
// ****************************** START: NOVE MENU ******************************
//
$(document).ready(function () {
    navHover();
});


$(document).on('keydown', function(event) {
    if (event.key == "Escape" && $('body').hasClass('nav-search-active')) {
        $('#q').val('');
        $('body').removeClass('nav-search-active nav-search');
        $('.header-search .search-inp').blur();
        $("#snippet--hledat .input-group").removeClass("loading");
    }
});


$(document).ready(function () {
    $("#nav-toggle").on('click tap', function() {
        initNav();
        if ($(this).hasClass('open')) {
            $("body").removeClass("nav-open body-is-fixed");
            $(this).removeClass('open');
            $("#navigation .nav-level").removeClass("nav-level-open nav-level-over");
            $('#navigation *').removeClass("nav-level-row-over nav-level-col-over nav-level-item-over");
            return false;
        } else {
            $("body").addClass("nav-open body-is-fixed");
            $(this).addClass('open');
            return false;
        }
    });


    $(".js-nav-user-toggle").on('click tap', function() {
        if ( $( "#nav-toggle" ).hasClass( "open" ) ) {
            $('#nav-user-logged-in').trigger('click');
        }
        else{
            $('#nav-toggle').trigger('click');
            $('#nav-user-logged-in').trigger('click');
        }

    });


    $(document).click(function (e) {
        if ($(e.target).closest('#nav-search, #snippet--search').length) {
			$('#nav-search').addClass('expanded');
            $('body').addClass('nav-search body-is-fixed').removeClass('nav-open ');
            $('#nav-search .search-inp').focus();
            $('.nav-head-level-2 > li:not(#nav-search):not(#nav-search-close)').addClass('disabled');
            $('#nav-search-close').removeClass('disabled');
            $('#navigation, .nav-inner').animate({
                scrollTop: 0
            }, 300);

			$('.searchAutocomplete-snippet').addClass('expanded');
        }

        if ($(window).width() > 991) {
            if ((!$(e.target).closest('#nav-search, #snippet--search').length) || ($(e.target).closest('#search-desktop-close').length) ) {
                $('#nav-search').removeClass('expanded');
				$('#snippet--searchAutocomplete').removeClass('expanded');
                $('body').removeClass('nav-search body-is-fixed');
                $('#nav-search .search-inp').blur();
                $('.nav-head-level-2 > li:not(#nav-search):not(#nav-search-close)').removeClass('disabled');
                $('#nav-toggle').removeClass('open');
                $('#nav-search-close').addClass('disabled');
                $("#navigation .nav-level").removeClass("nav-level-open nav-level-over");
                $('#navigation *').removeClass("nav-level-row-over nav-level-col-over nav-level-item-over");
            }
        }
    });

    $('#nav-search-close').on('click', function (e) {
        $('#nav-search').removeClass('expanded');
        $('body').removeClass('nav-search nav-search-active body-is-fixed');
        $('#nav-search .search-inp').blur();
        $('.nav-head-level-1 > li').removeClass('disabled');
        $('#nav-toggle').removeClass('open');
        $('#nav-search-close').addClass('disabled');
        $("#navigation .nav-level").removeClass("nav-level-open nav-level-over");
        $('#navigation *').removeClass("nav-level-row-over nav-level-col-over nav-level-item-over");
        if ($('body').hasClass('seach-m-hidden--helper')) {
            $('body').addClass('search-m-hidden');
        };

		$('.searchAutocomplete-snippet').removeClass('expanded');
    });


	// handling closing search snippet on click of the content overlay
	$(document).on('click', '.searchAutocomplete-overlay, .searchAutocomplete-close', function (e) {
		$('.searchAutocomplete-snippet').removeClass('expanded');
		$('body').removeClass('body-is-fixed');
	});
	// preventing the search snippet from being closed by clicking on itself
	$(document).on('click', '.searchAutocomplete', function (e) {
		e.stopPropagation();
	});


    $("#snippet--hledat .input-group input").removeAttr('disabled');
    $("#snippet--hledat").removeClass('disabled');
});
//
// ****************************** END: NOVE MENU ******************************
//


function getModal(page_id, type, setup, title, desc){
    type = (typeof type !== 'undefined') ?  type : 'page';
    setup = (typeof setup !== 'undefined') ?  setup : 'medium';
    title = (typeof title !== 'undefined') ?  title : '';
    desc = (typeof desc !== 'undefined') ?  desc : '';
    var mmodal = '';
    var mdialog = '';
    var mcontent = '';
    //console.log(type);

    if((type === "page") || (setup === "medium")){
        mdialog = '';
        mcontent = 'p-3';
    }

    if(type === "youtube"){
        mmodal = 'modal-destroy-me';
        mdialog = 'modal-lg';
        mcontent = '';
    }

    if(page_id === 'prebasket'){
        mdialog = 'modal-xl modal-dialog--padding';
        mcontent = '';
    }

    if(type === 'table'){
        mdialog = 'modal-dialog--padding modal-xl';
        mcontent = 'p-3 modal-content--overflow';
    }

    if(setup === 'auto'){
        mdialog = 'modal-lg';
        mcontent = 'p-3';
    }

    if(setup === 'small'){
        mdialog = 'modal-lg';
        mcontent = 'p-3';
    }

    if(setup === "large"){
        mdialog = 'modal-lg';
        mcontent = 'p-3';
    }

    if(setup === "xlarge"){
        mdialog = 'modal-lg';
        mcontent = 'p-3';
    }

    var str = $.parseHTML('<div class="modal ' + mmodal + ' fade font-family-title modal-blurred" id="'+page_id+'" tabindex="-1" role="dialog" aria-labelledby="'+page_id+'" aria-hidden="true"><button type="button" class="close modal__close color-shop--hover collapse show" id="popup-modal-close" data-dismiss="modal" aria-label="Close"><i class="svg-icon"><svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 320 512"><path d="M193.94 256L296.5 153.44l21.15-21.15c3.12-3.12 3.12-8.19 0-11.31l-22.63-22.63c-3.12-3.12-8.19-3.12-11.31 0L160 222.06 36.29 98.34c-3.12-3.12-8.19-3.12-11.31 0L2.34 120.97c-3.12 3.12-3.12 8.19 0 11.31L126.06 256 2.34 379.71c-3.12 3.12-3.12 8.19 0 11.31l22.63 22.63c3.12 3.12 8.19 3.12 11.31 0L160 289.94 262.56 392.5l21.15 21.15c3.12 3.12 8.19 3.12 11.31 0l22.63-22.63c3.12-3.12 3.12-8.19 0-11.31L193.94 256z"></path></svg></i></button><div class="modal-dialog ' + mdialog + ' modal-dialog-centered align-items-center" role="document"><div class="modal-paste-content ' + mcontent + '"><div class="text-center  font-em-35 color-white"><i class="svg-icon"><svg class="svg-icon svg-loader" version="1.1" xmlns="http://www.w3.org/2000/svg" fill="currentColor" x="0px" y="0px" width="40px" height="40px" viewBox="0 0 50 50" style="enable-background:new 0 0 50 50;" xml:space="preserve"><path d="M43.935,25.145c0-10.318-8.364-18.683-18.683-18.683c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615c8.072,0,14.615,6.543,14.615,14.615H43.935z" transform="rotate(62.2038 25 25)"><animateTransform attributeType="xml" attributeName="transform" type="rotate" from="0 25 25" to="360 25 25" dur="0.6s" repeatCount="indefinite"></animateTransform></path></svg></i></div></div></div></div>');

    if(type === 'content') {
        var content = $("#"+page_id).html();
        var inst = $(str).children(".modal-paste-content").addClass('modal-content').html(content);
    }

    if(type === 'youtube') {
        var content = $.parseHTML('<div id="iframe-video" class="iframe-video-wrap"><iframe frameborder="0" allowfullscreen="" class="_rounded" src="//www.youtube.com/embed/'+page_id+'?autoplay=1"></iframe></div>');
        var inst = $(str).find(".modal-paste-content").addClass('modal-content').html(content);
    }

    return str;
}


$(document).ready(function () {
    $("[data-getmodal-content]").on('click', function (e) {
        var page_id = $(this).attr("data-getmodal-content");
        var type = "content";
        var setup = $(this).attr("data-getmodal-setup");
        var title = $(this).attr("data-getmodal-title");
        var desc = $(this).attr("data-getmodal-desc");
        var str = getModal(page_id, type, setup, title, desc);
        obj = $(str).modal('show');
        e.preventDefault();
    });

    $("[data-getmodal-youtube]").on('click', function (e) {
        var page_id = $(this).attr("data-getmodal-youtube");
        var type = "youtube";
        var setup = $(this).attr("data-getmodal-setup");
        if ($(this).attr("data-getmodal-title")) {
            var title = $(this).attr("data-getmodal-title");
        } else {
            var title = document.title;
        }

        var desc = $(this).attr("data-getmodal-desc");
        var str = getModal(page_id, type, setup, title, desc);
        obj = $(str).modal('show');
        e.preventDefault();
        $('#'+page_id).on('hidden.bs.collapse', function () {
            $(this).remove();
            $('.modal-youtu').find('iframe').remove();
            $('.modal-youtu').modal('dispose');
        });
    });

    /* globalni odpocet */

    $('[data-countdown]').each(function() {
        var $this = $(this), finalDate = $(this).data('countdown');
        $this.countdown(finalDate, function(event) {
            $this.html(event.strftime('%H:%M:%S'));
        });
    });
});

$(document).on('hidden.bs.modal', '.modal', function () { $(".modal-destroy-me").remove(); });


/**
 * global handling - close&scroll from modal
 */
function closeModalAndScrollToTarget(modalId, target) {
	$("#" + modalId).modal('hide')
	setTimeout(function() {
		document.getElementById(target).scrollIntoView({ behavior: 'smooth' });
	}, 300)
}
